import PageFeature from '../pages/PageFeature.js'
import imgKasir from '../assets/background-kasir.jpg'

function App() {
    return <div>
        <div style={{ backgroundImage: `url(${imgKasir})`, width: '100%', height: '70vh', backgroundSize: 'cover' }}>
            <div className="bg-banner d-flex align-items-center" style={{ height: '100%' }}>
                <div className='container'>
                    <h2 className='text-end' style={{ color: 'white', fontWeight: 'bold' }}>Aplikasi KASIR BAGUS <br />Untuk Manajemen Perusahaan Anda</h2>
                </div>
            </div>
        </div>

        <div className='mt-5 mb-5'>
            <div className='container' style={{ textAlign: 'center' }}>
                <h1 className='text-center' style={{ fontWeight: 'bold' }}>BERBISNIS DENGAN NYAMAN DAN MENYENANGKAN DENGAN SISTEM KASIR YANG BAGUS</h1>
                <button className='btn btn-lg btn-primary mt-3'>COBA SEKARANG GRATIS</button>
            </div>
        </div>

        <hr />

        <PageFeature />

    </div>
}

export default App